<template lang="html">
  <content-block :controls="controls" :fresh="block.edit" @edit="editBlock()" @input="saveChanges()" @remove="deleteBlock()">
    <div v-if="edit">
      <div class="row">
        <label class="col-md-3">{{ $t('content_block_youtube_label') }}</label>
        <div class="col-md-9">
          <input  type="text" class="form-control" v-model="block.data.url" />
        </div>
      </div>
    </div>
    <div v-else="edit" class="content_block__youtube">
      <iframe width="560" height="315" frameborder="0"
              allow="autoplay; encrypted-media" allowfullscreen
              v-bind:src="'https://www.youtube.com/embed/' + block.data.url"></iframe>
    </div>
  </content-block>
</template>

<script>
  import ContentBlock from './ContentBlock'

export default {
  components: {
    ContentBlock
  },
  name: "ContentBlockYoutube",
  props: {
    block: {
      type: Object,
    },
    controls: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      edit: false
    }
  },
  mounted () {
    if (this.controls) {
      this.edit = this.block.edit || false;
    }
  },
  methods: {
    editBlock () {
      this.edit = true;
    },
    deleteBlock () {
      this.$emit('remove')
    },
    saveChanges() {
      this.edit = false;
      this.$emit('input', this.block)
    }
  }
}
</script>
